import styles from "./client-status-group.module.css";

import { ClientProfileSettings } from "../store/types";
import { inject, observer } from "mobx-react";
import { Component } from "react";
import { FeatureStore } from "../../../store";
import { StatusIcon } from "../../../components/status-icon/status-icon";

interface IClientAlertStatusProps {
  featureStore?: FeatureStore;
  clientSettings: ClientProfileSettings;
  disabled?: boolean;
  alertPeriodId: number;
}

@inject("featureStore")
@observer
export default class ClientAlertStatusIcons extends Component<IClientAlertStatusProps> {
  public render() {
    const icons = this.createAlertStatusIcons();
    return (
      <div className={styles["status-group"]}>
        {icons.map((Icon) => {
          return Icon;
        })}
      </div>
    );
  }

  private createAlertStatusIcons() {
    const { clientSettings, alertPeriodId, disabled } = this.props;
    const { alerts } = clientSettings;
    const iconTypes = this.createSortedAlertIcons();
    if (!clientSettings.alerts) {
      return [];
    }
    let icons = [];
    icons = iconTypes.map((iconType, index) => {
      const alert = alerts[alertPeriodId].find(
        (a) => a.typeId === iconType.alertId
      );
      if (alert === undefined) return <div />;

      const iconProps = {
        alertId: alert.typeId,
        alertDelayed: alert!.delay! > 0,
        alertActive: alert.isActive,
        alertDisabled: disabled,
      };

      return (
        <div className={styles["icon"]}>
          <StatusIcon key={alert.name + "_" + index} {...iconProps} />
        </div>
      );
    });
    return icons;
  }

  private createSortedAlertIcons() {
    const { featureList } = this.props.featureStore!;

    const alerts = [
      { alertId: 7 },
      { alertId: 4 },
      { alertId: 1 },
      { alertId: 2 },
      { alertId: 8 },
      { alertId: 3 },
      { alertId: 5 },
    ];

    if (featureList.isVoiceAlertAvailable === false) {
      const voiceAlertIndex = alerts.findIndex((alert) => {
        return alert.alertId === 7;
      });
      if (voiceAlertIndex >= 0) alerts.splice(voiceAlertIndex, 1);
    }

    return alerts;
  }
}
